import CenterWiseReportTypes from './center-wise-report.type';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
    centerWiseReportData: null,
    centerWiseReportResponse: null,
};

const centerWiseReportReducer = (state = INITIAL_STATE, action: any) => {
    switch (action.type) {
        case CenterWiseReportTypes.GET_CENTER_WISE_REPORT_SUCCESS: {
            const decodedData = docodeHexResponse(action.payload, 'GetCenterWiseReportKey');
            return {
                ...state,
                centerWiseReportData: decodedData,
                centerWiseReportResponse: action.payload,
            };
        }
        case CenterWiseReportTypes.GET_CENTER_WISE_REPORT_FAILURE:
            return {
                ...state,
                centerWiseReportData: null,
                centerWiseReportResponse: action.payload,
            };
        case CenterWiseReportTypes.GET_CENTER_WISE_REPORT_RESPONSE_RESET:
            return {
                ...state,
                centerWiseReportResponse: null,
            };
        default:
            return state;
    }
};

export default centerWiseReportReducer;
